import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from "react-admin";
import * as baker from "./cookie";

const server_url = window.config.apiRoot;


function fetchUserProfile(root_url, token) {
  const request = new Request(`${root_url}/user`, {
    method: "GET",
    body: JSON.stringify(),
    headers: new Headers({'Authorization' : `Token ${token}`})
  });
  return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
}


export default (type, params) => {
  // called when the user attempts to log in
  if (type === AUTH_LOGIN) {
    const { username, password } = params;
    const request = new Request(server_url + "/admin/spa/signin", {
      method: "POST",
      body: JSON.stringify({ email: username, password }),
      headers: new Headers({ "Content-Type": "application/json" })
    });
    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(({ token }) => {
        localStorage.setItem("token", token);
        return Promise.resolve();
      });
  }
  // called when the user clicks on the logout button
  if (type === AUTH_LOGOUT) {
    const token = localStorage.getItem("token");
    if (token  === null) {
        return Promise.resolve();
    }

    localStorage.removeItem("token");
    localStorage.removeItem("permissions");

    const request = new Request(server_url + "/logout", {
      method: "POST",
      headers: new Headers({'Authorization': `Token ${token}`})
    })

    return fetch(request)
        .then(response => {
          if(response.status < 200 || response.status >= 300) {
            throw new Error(response.statusText);
          }
        })
        .then(() => {
          return Promise.resolve();
        })
        .catch(error => {
          throw new Error(error);
          return Promise.reject();
        })

  }
  // called when the API returns an error
  if (type === AUTH_ERROR) {
    const { status } = params;
    if (status === 401 || status === 403) {
      localStorage.removeItem("token");
      return Promise.reject();
    }
    return Promise.resolve();
  }
  // called when the user navigates to a new location
  if (type === AUTH_CHECK) {
    if (process.env.NODE_ENV !== "production") {
      debugger;
    }

    if (localStorage.getItem("token")) {
      return Promise.resolve();
    }

    const spa_token = baker.getCookie("spa_token");
    if (!spa_token) {
      return Promise.reject();
    }

    localStorage.setItem("token", spa_token);
    baker.deleteCookie('spa_token');
    return Promise.resolve();
  }

  return Promise.reject("Unknown method");
};
